module.exports = __webpack_public_path__ + "img/nodata@2x.7f0c3735.png";